import { node, string } from 'prop-types';
import React from 'react';

import ContentWrapper from 'shared/components/layout/ContentWrapper';

const Article = ({ index, children }) => (
  <div className={`frontpage-article frontpage-article--${index}`}>
    <ContentWrapper>{children}</ContentWrapper>
  </div>
);

Article.propTypes = {
  index: string.isRequired,
  children: node.isRequired,
};

export default Article;
